import React from 'react';
import CardCommon from '@op/components/CardCommon';
import { Row } from 'tea-component';
import '@/pages/opinion/assets/scss/pages/feeds/GameStore.scss';
import { useIntl } from 'umi';
import opencriticIcon from '@op/assets/svg/channel/opencritic.svg';
import xboxIcon from '@op/assets/svg/channel/xbox.svg';
import './GameStorePcScore.scss';
import VerticalMinScoreBox from '../../components/VerticalMinScoreBox';
import useShowBtnHooks from '@/pages/opinion/hooks/useShowBtnHooks';
import useGetPcConsoleStats from '@/pages/opinion/pages/gamestore/hooks/useGetPcConsoleStats';

export default function GameStoreConsoleScore({
  filter,
  gameInfo,
  hasXbox = false,
  channel,
}: any) {
  const { formatMessage } = useIntl();

  const {
    userScore,
    userScoreLoading: loading,
    userScoreApiError,
  } = useGetPcConsoleStats({
    keepParams: filter,
    channel,
    needLink: false,
  });

  const { isShowBtn, cardListRef, showMore, clickShowMore } = useShowBtnHooks({
    loading,
    minHeight: 300,
  });

  return (
    <CardCommon
      className={`feeds-game-store-pc-score dbo-console feeds-userscorebox  feeds-userscorebox--2 ${
        showMore ? 'show-all' : ''
      }`}
      title={formatMessage({ id: 'User Score' })}
      loading={loading}
      loadingHeight={200}
      emptyHeight={200}
    >
      <div>
        <Row className="feeds-userscorebox-row" ref={cardListRef}>
          <VerticalMinScoreBox
            className="dbo-scorebox"
            title="Lifetime Reviews"
            hasEmptyTitle
            channel="metacritic"
            dataKeys={['meta_score', 'user_score']}
            data={userScore.metacritic || {}}
          ></VerticalMinScoreBox>

          <VerticalMinScoreBox
            className="dbo-scorebox"
            title="Lifetime Reviews"
            hasEmptyTitle
            channel="opencritic"
            dataKeys={['top_critic_average', 'critics_recommend']}
            data={userScore.opencritic || {}}
          ></VerticalMinScoreBox>
        </Row>
        {isShowBtn && (
          <div className="feeds-userscorebox-more" onClick={clickShowMore}>
            {showMore ? (
              <span>{formatMessage({ id: 'Show Less' })}</span>
            ) : (
              <>
                <span>{formatMessage({ id: 'Show' })}</span>
                <img
                  className="channel-icon"
                  src={hasXbox ? xboxIcon : opencriticIcon}
                />{' '}
                {hasXbox ? 'Xbox' : 'OpenCritic'}
              </>
            )}
          </div>
        )}
      </div>
    </CardCommon>
  );
}
